import React from 'react';
import { motion } from 'framer-motion';
export function AboutSection() {
  return <section className="py-32 md:py-48 px-6 flex flex-col items-center justify-center relative" data-id="element-13">
      <div className="w-full max-w-4xl text-center" data-id="element-14">
        <motion.p initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="font-heading text-2xl md:text-4xl text-brand-offWhite leading-relaxed font-light tracking-wide" data-id="element-15">
          We partner with ideas, operators, and projects positioned at the edge
          of culture and technology.
        </motion.p>
      </div>
    </section>;
}